module.exports = __webpack_public_path__ + "img/010026.1b72bf5e.png";